"use strict";

function _interopDefault(ex) {
  return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var React = _interopDefault(require("react"));
var PropTypes = _interopDefault(require("prop-types"));
var resizeObserver = require("resize-observer");
var reactPortal = require("react-portal");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const ALIGN = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center"
};
const PLACEMENT = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
};
const VALIGN = {
  TOP: "top",
  BOTTOM: "bottom",
  CENTER: "center"
};
const BORDER_WIDTH = 1;
const CARET_SIZE = 8;

var objectValues = obj => Object.keys(obj).map(key => obj[key]);

const PopoverContent = React.forwardRef((_ref, ref) => {
  let {
      caretPosition,
      caretVisible: isCaretVisible,
      children = null,
      focusTarget,
      placement,
      position,
      style,
      visible: isVisible
    } = _ref,
    rest = _objectWithoutProperties(_ref, [
      "caretPosition",
      "caretVisible",
      "children",
      "focusTarget",
      "placement",
      "position",
      "style",
      "visible"
    ]);

  return React.createElement(
    reactPortal.Portal,
    null,
    React.createElement(
      "span",
      _extends({}, rest, {
        "data-react-popover-content": true,
        ref: ref,
        style: _objectSpread2({}, style, {}, position, {
          visibility: isVisible ? "visible" : "hidden"
        }),
        tabIndex: -1
      }),
      isCaretVisible &&
        React.createElement(
          "span",
          _extends(
            {
              "data-react-popover-caret": true
            },
            {
              [`data-react-popover-caret-${placement}`]: true
            },
            {
              style: caretPosition
            }
          )
        ),
      React.createElement("span", {
        "data-react-popover-tab": true,
        onFocus: focusTarget,
        tabIndex: 0
      }),
      React.createElement("span", {
        "data-react-popover-focus": true,
        tabIndex: -1
      }),
      children,
      React.createElement("span", {
        "data-react-popover-tab": true,
        onFocus: focusTarget,
        tabIndex: 0
      })
    )
  );
});
PopoverContent.displayName = "PopoverContent";
PopoverContent.propTypes = {
  caretPosition: PropTypes.shape({
    left: PropTypes.string,
    top: PropTypes.string
  }),
  children: PropTypes.node,
  focusTarget: PropTypes.func,
  isCaretVisible: PropTypes.bool,
  placement: PropTypes.oneOf(objectValues(PLACEMENT)),
  position: PropTypes.shape({
    left: PropTypes.string,
    top: PropTypes.string
  }).isRequired,
  visible: PropTypes.bool.isRequired
};

const PopoverTarget = React.forwardRef((_ref, ref) => {
  let { children } = _ref,
    rest = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(
    "button",
    _extends(
      {
        "data-react-popover-target": true,
        ref: ref,
        type: "button"
      },
      rest
    ),
    children
  );
});
PopoverTarget.displayName = "PopoverTarget";

const CARET_OFFSET_MIN_TARGET_SIZE = 32;
var positionHelper = ({
  targetRect,
  contentRect,
  viewportRect,
  spacing,
  isCaretVisible,
  caretSize,
  borderWidth
}) => {
  const _calculatePosition = (placement, align) => {
    if (placement === PLACEMENT.LEFT || placement === PLACEMENT.RIGHT) {
      const hOffset = spacing + (isCaretVisible ? caretSize : 0);
      const left =
        placement === PLACEMENT.LEFT
          ? `${targetRect.left - contentRect.width - hOffset}px`
          : `${targetRect.right + hOffset}px`;

      const top = (() => {
        switch (align) {
          case VALIGN.TOP:
            return isCaretVisible &&
              targetRect.height <= CARET_OFFSET_MIN_TARGET_SIZE
              ? `${targetRect.top -
                  (CARET_OFFSET_MIN_TARGET_SIZE / 2 - targetRect.height / 2) -
                  borderWidth}px`
              : `${targetRect.top}px`;

          case VALIGN.BOTTOM:
            return isCaretVisible &&
              targetRect.height <= CARET_OFFSET_MIN_TARGET_SIZE
              ? `${targetRect.bottom -
                  contentRect.height +
                  (CARET_OFFSET_MIN_TARGET_SIZE / 2 - targetRect.height / 2) -
                  borderWidth}px`
              : `${targetRect.bottom - contentRect.height}px`;

          default:
            return `${targetRect.top +
              targetRect.height / 2 -
              contentRect.height / 2}px`;
          // center
        }
      })();

      return {
        left,
        top
      };
    } else {
      const vOffset = spacing + (isCaretVisible ? caretSize : 0);

      const left = (() => {
        switch (align) {
          case ALIGN.LEFT:
            return isCaretVisible &&
              targetRect.width <= CARET_OFFSET_MIN_TARGET_SIZE
              ? `${targetRect.left -
                  (CARET_OFFSET_MIN_TARGET_SIZE / 2 - targetRect.width / 2) -
                  borderWidth}px`
              : `${targetRect.left}px`;

          case ALIGN.RIGHT:
            return isCaretVisible &&
              targetRect.width <= CARET_OFFSET_MIN_TARGET_SIZE
              ? `${targetRect.right -
                  contentRect.width +
                  (CARET_OFFSET_MIN_TARGET_SIZE / 2 - targetRect.width / 2) -
                  borderWidth}px`
              : `${targetRect.right - contentRect.width}px`;

          default:
            return `${targetRect.left +
              targetRect.width / 2 -
              contentRect.width / 2}px`;
          // center
        }
      })();

      const top =
        placement === PLACEMENT.TOP
          ? `${targetRect.top - contentRect.height - vOffset}px`
          : `${targetRect.bottom + vOffset}px`;
      return {
        left,
        top
      };
    }
  };

  const _calculateCaretPosition = (placement, align) => {
    if (placement === PLACEMENT.LEFT || placement === PLACEMENT.RIGHT) {
      const left = placement === PLACEMENT.LEFT ? "100%" : `-${caretSize}px`;

      const top = (() => {
        if (align === VALIGN.TOP || align === VALIGN.BOTTOM) {
          const caretOffset =
            targetRect.height <= CARET_OFFSET_MIN_TARGET_SIZE ||
            targetRect.height > contentRect.height
              ? caretSize
              : targetRect.height / 2 - caretSize;

          if (align === VALIGN.BOTTOM) {
            const CARET_HEIGHT = caretSize * 2;
            return `${contentRect.height - (caretOffset + CARET_HEIGHT)}px`;
          } else {
            return `${caretOffset}px`;
          }
        } else {
          return `${contentRect.height / 2 - borderWidth - caretSize}px`; // center
        }
      })();

      return {
        left,
        top
      };
    } else {
      const left = (() => {
        if (align === ALIGN.LEFT || align === ALIGN.RIGHT) {
          const caretOffset =
            targetRect.width <= CARET_OFFSET_MIN_TARGET_SIZE ||
            targetRect.width > contentRect.width
              ? caretSize
              : targetRect.width / 2 - caretSize;

          if (align === ALIGN.RIGHT) {
            const CARET_WIDTH = caretSize * 2;
            return `${contentRect.width - (caretOffset + CARET_WIDTH)}px`;
          } else {
            return `${caretOffset}px`;
          }
        } else {
          return `${contentRect.width / 2 - borderWidth - caretSize}px`; // center
        }
      })();

      const top = placement === PLACEMENT.TOP ? "100%" : `-${caretSize}px`;
      return {
        left,
        top
      };
    }
  };

  const _getPlacement = preferred => {
    // Two checks for each;
    // 1) Will the content fit for the preferred placement?
    // 2) If not, will the content fit for the alternate placement?
    const offset = spacing + (isCaretVisible ? caretSize : 0);

    if (
      preferred === PLACEMENT.TOP &&
      targetRect.top - contentRect.height - offset < viewportRect.top
    ) {
      if (
        targetRect.bottom + contentRect.height + offset <
        viewportRect.bottom
      ) {
        return PLACEMENT.BOTTOM;
      }
    } else if (
      preferred === PLACEMENT.BOTTOM &&
      targetRect.bottom + contentRect.height + offset > viewportRect.bottom
    ) {
      if (targetRect.top - contentRect.height - offset > viewportRect.top) {
        return PLACEMENT.TOP;
      }
    } else if (
      preferred === PLACEMENT.LEFT &&
      targetRect.left - contentRect.width - offset < viewportRect.left
    ) {
      if (targetRect.right + contentRect.width + offset < viewportRect.right) {
        return PLACEMENT.RIGHT;
      }
    } else if (
      preferred === PLACEMENT.RIGHT &&
      targetRect.right + contentRect.width + offset > viewportRect.right
    ) {
      if (targetRect.left - contentRect.width - offset > viewportRect.left) {
        return PLACEMENT.LEFT;
      }
    }

    return preferred;
  };

  const _getAlignment = (placement, preferred) => {
    // Two checks for each;
    // 1) Will the content fit for the preferred placement?
    // 2) If not, will the content fit for the alternate placement?
    const offset = spacing + caretSize;

    if (placement === PLACEMENT.LEFT || placement === PLACEMENT.RIGHT) {
      if (
        (preferred === VALIGN.TOP &&
          targetRect.top + contentRect.height + offset > viewportRect.bottom) ||
        (preferred === VALIGN.CENTER &&
          targetRect.bottom +
            (contentRect.height - targetRect.height) / 2 +
            offset >
            viewportRect.bottom)
      ) {
        if (
          targetRect.bottom - contentRect.height - offset >
          viewportRect.top
        ) {
          return VALIGN.BOTTOM;
        }
      } else if (
        (preferred === VALIGN.BOTTOM &&
          targetRect.bottom - contentRect.height - offset < viewportRect.top) ||
        (preferred === VALIGN.CENTER &&
          targetRect.top -
            (contentRect.height - targetRect.height) / 2 -
            offset <
            viewportRect.top)
      ) {
        if (
          targetRect.top + contentRect.height + offset <
          viewportRect.bottom
        ) {
          return VALIGN.TOP;
        }
      }
    } else {
      if (
        (preferred === ALIGN.LEFT &&
          targetRect.left + contentRect.width + offset > viewportRect.right) ||
        (preferred === ALIGN.CENTER &&
          targetRect.right +
            (contentRect.width - targetRect.width) / 2 +
            offset >
            viewportRect.right)
      ) {
        if (targetRect.right - contentRect.width - offset > viewportRect.left) {
          return ALIGN.RIGHT;
        }
      } else if (
        (preferred === ALIGN.RIGHT &&
          targetRect.right - contentRect.width - offset < viewportRect.left) ||
        (preferred === ALIGN.CENTER &&
          targetRect.left -
            (contentRect.width - targetRect.width) / 2 -
            offset <
            viewportRect.left)
      ) {
        if (targetRect.left + contentRect.width + offset < viewportRect.right) {
          return ALIGN.LEFT;
        }
      }
    }

    return preferred;
  };

  const getPosition = (preferredPlacement, preferredAlign, isFixed) => {
    const placement = isFixed
      ? preferredPlacement
      : _getPlacement(preferredPlacement);
    const align = isFixed
      ? preferredAlign
      : _getAlignment(placement, preferredAlign);

    const position = _calculatePosition(placement, align);

    const caretPosition = isCaretVisible
      ? _calculateCaretPosition(placement, align)
      : null;
    return {
      placement,
      position,
      caretPosition
    };
  };

  return {
    getPosition
  };
};

const initialState = {
  caretPosition: null,
  placement: null,
  position: {
    left: "-99999px",
    top: "-99999px"
  }
};
const reducer = (state, action) => {
  const { target, content } = action;
  const {
    align,
    borderWidth,
    caretSize,
    isCaretVisible,
    isFixedPosition,
    isVisible,
    placement,
    spacing,
    valign
  } = action;
  const { innerHeight, innerWidth, pageXOffset, pageYOffset } = action;

  if (action.type === "POSITION_POPOVER") {
    if (!isVisible) return initialState;

    const getRect = ref => {
      const rect = ref.getBoundingClientRect();
      return {
        bottom: rect.bottom + pageYOffset,
        height: ref.offsetHeight || ref.clientHeight,
        left: rect.left + pageXOffset,
        right: rect.right + pageXOffset,
        top: rect.top + pageYOffset,
        width: ref.offsetWidth || ref.clientWidth
      };
    };

    const targetRect = getRect(target);
    const contentRect = getRect(content);
    const viewportRect = {
      bottom: innerHeight + pageYOffset,
      left: pageXOffset,
      right: innerWidth + pageXOffset,
      top: pageYOffset
    };
    const helper = positionHelper({
      targetRect,
      contentRect,
      viewportRect,
      spacing,
      isCaretVisible,
      caretSize,
      borderWidth
    });

    const _align =
      [PLACEMENT.TOP, PLACEMENT.BOTTOM].indexOf(placement) !== -1
        ? align
        : valign;

    return helper.getPosition(placement, _align, isFixedPosition);
  }

  throw Error(`Action of type ${action.type} is not supported`);
};

const Popover = _ref => {
  let {
      align = "center",
      borderWidth = BORDER_WIDTH,
      caret: isCaretVisible = false,
      caretSize = CARET_SIZE,
      children = null,
      fixed: isFixedPosition = false,
      placement = "bottom",
      setVisible,
      spacing = 0,
      target,
      visible: isVisible,
      valign = "center"
    } = _ref,
    props = _objectWithoutProperties(_ref, [
      "align",
      "borderWidth",
      "caret",
      "caretSize",
      "children",
      "fixed",
      "placement",
      "setVisible",
      "spacing",
      "target",
      "visible",
      "valign"
    ]);

  const contentRef = React.useRef();
  const targetRef = React.useRef();
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const positionPopover = React.useCallback(() => {
    dispatch(
      _objectSpread2({}, window, {
        type: "POSITION_POPOVER",
        content: contentRef.current,
        target: targetRef.current,
        align,
        borderWidth,
        caretSize,
        isCaretVisible,
        isFixedPosition,
        isVisible,
        placement,
        spacing,
        valign
      })
    );

    if (isVisible) {
      contentRef.current.querySelector("[data-react-popover-focus]").focus();
    }
  }, [
    align,
    borderWidth,
    caretSize,
    isCaretVisible,
    isFixedPosition,
    isVisible,
    placement,
    spacing,
    valign
  ]);
  React.useEffect(() => {
    const resizeObserver$1 = new resizeObserver.ResizeObserver(positionPopover);
    const content = contentRef.current;
    resizeObserver$1.observe(content);
    return () => {
      resizeObserver$1.unobserve(content);
      resizeObserver$1.disconnect();
    };
  }, [positionPopover]);
  React.useEffect(() => {
    const hide = () => setVisible(false);

    window.addEventListener("resize", hide);
    return () => {
      window.removeEventListener("resize", hide);
    };
  }, [setVisible]);
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      PopoverTarget,
      {
        onClick: () => setVisible(true),
        ref: targetRef
      },
      target
    ),
    React.createElement(
      PopoverContent,
      _extends({}, props, state, {
        caretVisible: isCaretVisible,
        focusTarget: () => targetRef.current.focus(),
        onBlur: ({ relatedTarget }) => {
          if (!contentRef.current.contains(relatedTarget)) {
            setVisible(false);
          }
        },
        ref: contentRef,
        visible: isVisible
      }),
      children
    )
  );
};

Popover.propTypes = {
  align: PropTypes.oneOf(objectValues(ALIGN)),
  borderWidth: PropTypes.number,
  caret: PropTypes.bool,
  caretSize: PropTypes.number,
  children: PropTypes.node,
  fixed: PropTypes.bool,
  placement: PropTypes.oneOf(objectValues(PLACEMENT)),
  setVisible: PropTypes.func.isRequired,
  spacing: PropTypes.number,
  target: PropTypes.element.isRequired,
  valign: PropTypes.oneOf(objectValues(VALIGN)),
  visible: PropTypes.bool.isRequired
};

module.exports = Popover;
